/**
 * 343 (#937): the host a customer's share link chose (`/h/<name>`), kept on THIS DEVICE until they clear it or open
 * another host's link. `localStorage`, not the sign-in return path: that path lives in one tab's `sessionStorage`
 * and is lost when an email-verification link opens a new tab, so the filter would not survive a new customer's
 * sign-up. Only a well-formed name is ever kept or read back; it is the link's public name, not personal data.
 */
const KEY = 'carii.host_filter';
const NAME_RE = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

function wellFormed(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string') return null;
  const name = raw.trim().toLowerCase();
  return name.length >= 3 && name.length <= 40 && NAME_RE.test(name) ? name : null;
}

export function readHostFilter(): string | null {
  try {
    return wellFormed(localStorage.getItem(KEY));
  } catch {
    return null;
  }
}

/** Keeps a well-formed name (replacing any earlier one); false, and nothing changed, for anything else. */
export function writeHostFilter(raw: string): boolean {
  const name = wellFormed(raw);
  if (!name) return false;
  try {
    localStorage.setItem(KEY, name);
    return true;
  } catch {
    return false;
  }
}

export function clearHostFilter(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Storage unavailable: there is nothing stored to clear.
  }
}
